"use strict";

const IncidentFactSheetController = function () {
  var getConfig = function () {
    const IncidentsIcon = require("./incidentsIcon");
    const SortUtilities = require("../../general/sortUtilities");
    const DateTime = require("../../dateTime");
    const alphaSorter = SortUtilities.alphaSorter;
    const dateSorter = DateTime.dbDateStringComparator;

    return {
      template: "factSheet/incident/incidentFactSheet.njk",
      pointColumnName: "geom",
      iconFunction: IncidentsIcon.getIncidentsMarkerIcon,
      closeUrl: UrlRoutes.getDefaultUrl(),
      goToMapFunction: () => Analytics.sendDataListEvent("address_to_map"),
      getDataFunction: getData,
      prepareDataFunction: prepareData,
      onCloseFunction: onClose,
      afterOpenFunction: afterOpen,
      readOnlyPhotos: true,
      apiAssetName: "incident",
      dataSorting: {
        history: { key: "date", reversed: true },
      },
      tableTemplates: {
        history: "factSheet/incident/incidentHistoryRows.njk",
      },
      sortersDict: {
        displayType: alphaSorter,
        date: dateSorter,
        displayCondition: alphaSorter,
      },
    };
  };

  var getData = async function (id) {
    try {
      return await ApiCalls.getIncidentForFactSheet(id);
    } catch (e) {
      ApiError.assertIs(e);
      if (e.status === 404) {
        return e;
      }
    }

    return await ResourceController.get("incidents").getById(id);
  };

  var prepareData = function (data) {
    data.readOnlyTopLevel = Session.isRegulator();
    data.isFieldPersonnel = Session.isFieldPersonnel();
    FactSheetNew.addDisplayDates(data.history);
    data.dataView = Tree.get("dataView");

    const IncidentsIcon = require("./incidentsIcon");
    const iconColor = IncidentsIcon.getIconColor(data.incidentStatus) ?? "blue";
    data.statusColor = MapStyles.getHexColor(iconColor);
    data.statusTextColor = Misc.isDarkColor(data.statusColor) ? "#fff" : "#000";

    data.canIssueEnforcement = data.permissions.canIssueEnforcement;
  };

  var open = async function (id, options = {}) {
    FactSheetNew.open(id, getConfig(), null, options);
  };

  var afterOpen = function () {
    _loadListeners();
  };

  var _unloadListeners = function () {
    $("#fact-sheet-container")
      .off("click", ".edit-button", _clickEditButton)
      .off("click", ".edit-description", _clickEditDescription)
      .off("click", ".new-incident-investigation", _clickAddInvestigation)
      .off("click", ".js-issue-incident-enforcement", _clickIssueEnforcement)
      .off("click", ".js-edit-assessment", _editAssessmentClick)
      .off("click", ".js-view-assessment", _viewAssessmentClick)
      .off("click", ".js-delete-assessment", _deleteAssessmentClick)
      .off("click", ".download-report", _downloadReportClick)
      .off("click", ".js-edit-incident-enforcement", _editEnforcementClick)
      .off("click", ".js-view-incident-enforcement", _viewEnforcementClick)
      .off("click", ".js-delete-incident", _deleteIncidentClick);

    UnsubmitHistoryRecord.unloadDomListeners();
  };

  var _loadListeners = function () {
    _unloadListeners();
    $("#fact-sheet-container")
      .on("click", ".edit-button", _clickEditButton)
      .on("click", ".edit-description", _clickEditDescription)
      .on("click", ".new-incident-investigation", _clickAddInvestigation)
      .on("click", ".js-issue-incident-enforcement", _clickIssueEnforcement)
      .on("click", ".js-edit-assessment", _editAssessmentClick)
      .on("click", ".js-view-assessment", _viewAssessmentClick)
      .on("click", ".js-delete-assessment", _deleteAssessmentClick)
      .on("click", ".download-report", _downloadReportClick)
      .on("click", ".js-edit-incident-enforcement", _editEnforcementClick)
      .on("click", ".js-view-incident-enforcement", _viewEnforcementClick)
      .on("click", ".js-delete-incident", _deleteIncidentClick);

    UnsubmitHistoryRecord.loadDomListeners({
      recordType: "investigation",
      apiCall: async (id) => {
        await ApiCalls.unsubmitIncidentInvestigation(id);
        IncidentsGeoServerLayer.invalidateLayerData();
        await FactSheetNew.reload();
      },
    });
  };

  var onClose = function () {
    _unloadListeners();
  };

  var _clickEditButton = function () {
    IncidentInventoryModalController.invokeIncidentInventoryModal(FactSheetNew.getId());
  };

  var _clickEditDescription = function () {
    IncidentInventoryModalController.invokeIncidentInventoryModal(
      FactSheetNew.getId(),
      {},
      "incident-general-info",
    );
  };

  var _clickAddInvestigation = function () {
    IncidentInvestigationController.loadIncidentInvestigation({
      incidentId: FactSheetNew.getId(),
    });
  };

  var _clickIssueEnforcement = function () {
    IncidentEnforcementController.loadNewEnforcement(FactSheetNew.getId());
  };

  var _editAssessmentClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();
    IncidentHistory.editHistory(data, false);
  };

  var _viewAssessmentClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();
    IncidentHistory.editHistory(data, true);
  };

  var _deleteAssessmentClick = function () {
    const $row = FactSheetNew.$getRow($(this));
    const data = $row.data();
    IncidentHistory.confirmDeleteHistory($row, data);
  };

  var _downloadReportClick = async function () {
    const data = FactSheetNew.$getRow($(this)).data();
    await ApiCalls.downloadIncidentInvestigationPdf(data.id);
  };

  var _editEnforcementClick = function () {
    const id = $(this).data("id");
    IncidentEnforcementController.editEnforcementAction(id);
  };

  var _viewEnforcementClick = function () {
    const id = $(this).data("id");
    IncidentEnforcementController.viewEnforcementAction(id);
  };

  var _deleteIncidentClick = function () {
    const id = FactSheetNew.getId();
    const name = FactSheetNew.getData().incidentName;
    MessageModal.showConfirmWarningModal(
      `Delete incident ${name}? Click "Delete" to permanently delete the incident and all associated investigations, photos and files. Click "Cancel" to return.`,
      async function () {
        await ApiCalls.deleteIncident(id);
        IncidentsGeoServerLayer.invalidateLayerData();
        FactSheetNew.close();
      },
      "Cancel",
      "Delete",
    );
  };

  return {
    open,
    getConfig,
  };
};

module.exports = IncidentFactSheetController();

const Analytics = require("../../general/analytics");
const ApiCalls = require("../../apiCalls");
const ApiError = require("../../errors/apiError");
const FactSheetNew = require("../../general/factSheetNew");
const IncidentEnforcementController = require("../incidentEnforcement/incidentEnforcementController");
const IncidentHistory = require("./incidentHistory");
const IncidentInventoryModalController = require("./incidentInventoryModalController");
const IncidentInvestigationController = require("../incidentInvestigation/incidentInvestigationController");
const IncidentsGeoServerLayer = require("./incidentsGeoServerLayer");
const MapStyles = require("../../mapFunctions/mapStyles");
const MessageModal = require("../../modals/messageModal");
const Misc = require("../../misc");
const ResourceController = require("../../offline/resourceController");
const Session = require("../../login/session");
const Tree = require("../../tree");
const UnsubmitHistoryRecord = require("../../general/unsubmitHistoryRecord");
const UrlRoutes = require("../../routes/urlRoutes");
